import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import { type UserAccountValues } from "~/features/userAdministration/editUser/types/userAccountTypes";

function occManageUsersUrl(path: string, email: string) {
  return occUrl(`/manage-users${path}?user=${email}`);
}

interface ManageUserErrorDTO {
  error: string;
}

export async function actionsUserAccount(
  data: UserAccountValues,
  isEdit: boolean,
  isCreate: boolean,
  uid: string,
): Promise<string[]> {
  let url;
  if (isEdit) {
    url = occManageUsersUrl("/edit", data.email);
  } else if (isCreate) {
    url = occManageUsersUrl("/create", data.email);
  } else {
    url = occManageUsersUrl("/delete", data.email);
  }

  const isDelete = !(isEdit || isCreate);
  const commonData = {
    active: data.status === "true",
    role: data.role,
    uid: uid,
    email: data.email,
    firstName: data.firstName,
    lastName: data.lastName,
    jobTitle: data.jobTitle,
    functionalArea: data.functionalArea,
    phone: data.phone,
    salutationCode: data.salutation,
    titleCode: data.title,
    lmsRequest: data.lmsRequest,
    accountCodes: data.accountCodes.toString(),
    endCustomerCodes: data.endCustomerCodes.toString(),
  };
  const bodyData = !data.lmsRequest
    ? {
        ...commonData,
      }
    : {
        ...commonData,
        customerCategoryCode: data.customerCategoryCode,
        knowledgeAreaCode: data.knowledgeAreaCode,
        languageIsoCode: data.languageIsoCode,
        vatNumber: data.vatNumber,
      };

  const response = await occFetch(url, {
    body: isDelete ? undefined : JSON.stringify(bodyData),
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
  });
  if (!response.ok) {
    if (isDelete) {
      return [await response.text()];
    }
    const responseBody = (await response.json()) as ManageUserErrorDTO;
    return [responseBody.error];
  } else {
    return [];
  }
}
